export function operacionCosto(col, Porc){
  return col * (1 + (Porc/100));
}